module.exports = __webpack_public_path__ + "img/audio.65c9aedf.jpg";